export const axisRegex = /^-?\d*\.?\d+$/; // Regex to match integer, float, and negative values

export const fullNameRegex = /^[a-zA-Z]+ [a-zA-Z]+$/;

export const mobileRegex = /^[0-9]{10}$/;

export const zipCodeRegex = /^(?:\d{5}|\d{5}-\d{4})$/; // utility function for check US ZIP code validation.
